<template>
  <Pie :data="chartData" :options="chartOptions" />
</template>
<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { useThemeHelper } from "@/theme/themeHelper"
  import { Pie } from "vue-chartjs"
  import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    ArcElement,
    ChartData,
    ChartOptions,
  } from "chart.js"

  ChartJS.register(Tooltip, Legend, ArcElement)

  export default defineComponent({
    inheritProps: false,
    components: { Pie },
    props: {
      dataSet: {
        type: Array as PropType<Array<number>>,
        default: () => [],
      },
      labels: {
        type: Array as PropType<Array<string>>,
        default: () => [],
      },
      backgroundColors: {
        type: Array as PropType<Array<string>>,
        default: () => [],
      },
      maintainAspectRatio: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        currentTheme: useThemeHelper(),
      }
    },
    computed: {
      chartOptions() {
        const chartOptions: ChartOptions<"pie"> = {
          responsive: true,
          maintainAspectRatio: this.maintainAspectRatio,
          color: this.currentTheme.colors["on-background"],
        }
        return chartOptions
      },
      chartData() {
        // https://www.chartjs.org/docs/latest/charts/doughnut.html#pie
        const chartData: ChartData<"pie"> = {
          labels: this.labels,
          datasets: [
            {
              data: this.dataSet,
              backgroundColor: this.backgroundColors,
              borderColor: [],
              borderWidth: 1,
            },
          ],
        }
        return chartData
      },
    },
  })
</script>
